export enum SupplierCategory {
  ParentOrganization = 'ParentOrganization',
  Supplier = 'Supplier',
  Manufacturer = 'Manufacturer',
  Division = 'Division',
}
